import React, { useState } from 'react';
import axios from 'axios';

const URL = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/`

const UploadExcelForm = () => {
  const [tableName, setTableName] = useState('');
  const [file, setFile] = useState(null);

  // פונקציה לטיפול בשינוי שדה הסלקט
  const handleTableChange = (e) => {
    setTableName(e.target.value);
  };

  // פונקציה לטיפול בבחירת קובץ אקסל
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // פונקציה לשליחת הנתונים לשרת
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!tableName || !file) {
      alert('יש לבחור שם רשומה ולהעלות קובץ.');
      return;
    }

    const formData = new FormData();
    formData.append('tableName', tableName);
    formData.append('file', file);

    console.log('tableName: ',tableName);
    console.log('file: ',file);

    try {
      const response = await axios.post(URL + `api/uploadFiles/upload-excel`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      alert(response.data.message);
    } catch (error) {
      console.error('שגיאה בשליחת הנתונים:', error);
      alert('שגיאה בשליחת הנתונים לשרת.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label htmlFor="tableName">שם הרשומה:</label>
        <select id="tableName" value={tableName} onChange={handleTableChange} required>
          <option value="">בחר שם רשומה</option>
          <option value="cemeteries">Cemeteries</option>
          <option value="blocks">Blocks</option>
          <option value="plots">Plots</option>
          <option value="rows">Rows</option>
          <option value="areaGraves">Area Graves</option>
          <option value="graves">Graves</option>
          <option value="customers">Customers</option>
          <option value="purchases">Purchases</option>
          <option value="burials">Burials</option>
          <option value="countries">Countries</option>
          <option value="cities">Cities</option>
        </select>
      </div>

      <div>
        <label htmlFor="file">העלה קובץ אקסל:</label>
        <input type="file" id="file" accept=".xlsx, .xls" onChange={handleFileChange} required />
      </div>

      <button type="submit">שלח</button>
    </form>
  );
};

export default UploadExcelForm;
